import { REDUCED_MOTION_MEDIA_QUERY } from '@packages/shared-ui';
import { ScreenSize } from '@/styles/legacyComponentLibraryTheme';
import { makeStyles } from '@/styles/theme/tss-react';

const useStyles = makeStyles({
  name: 'Dropdown',
})(({ breakpoints, brandColors, type, spacing, typography }) => ({
  dropdown: {
    display: 'flex',
    background: 'rgba(255, 252, 245, 1)',
    width: '100%',
    listStyle: 'none',
    flexDirection: 'column',
    padding: `${spacing(1)} ${typography.pxToRem(24)} ${spacing(
      3
    )} ${typography.pxToRem(24)}`,

    [breakpoints.up('md')]: {
      padding: `${spacing(1)} ${typography.pxToRem(40)} ${spacing(
        3
      )} ${typography.pxToRem(40)}`,
    },
    [breakpoints.up('md')]: {
      padding: `${spacing(1)} ${typography.pxToRem(64)} ${spacing(
        3
      )} ${typography.pxToRem(64)}`,
      alignItems: 'center',
    },
    [breakpoints.up('lg')]: {
      padding: `${spacing(1)} ${typography.pxToRem(80)} ${spacing(
        3
      )} ${typography.pxToRem(80)}`,
    },
  },
  dropdownFixedGrid: {
    [breakpoints.up('md')]: {
      padding: `${spacing(1)} 0 ${spacing(3)}`,
      alignItems: 'center',
    },
  },
  dropdownDark: {
    background: brandColors.tintsHeroBlue10,
  },
  pageTitle: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    color: brandColors.mediumBlue,
  },
  pageTitleDark: {
    color: brandColors.tintsChargeBlue60,
  },
  innerWrapper: {
    display: 'flex',
    flexDirection: 'column',
    margin: 'auto',
    width: '100%',
    maxWidth: ScreenSize.LARGE,
    [breakpoints.up('md')]: {
      flexDirection: 'row',
      gap: typography.pxToRem(40),
    },
    [breakpoints.up('lg')]: {
      gap: spacing(2),
      maxWidth: typography.pxToRem(1280),
    },
  },
  innerWrapperFixedGrid: {
    margin: 0,
    maxWidth: 'none',
  },
  dropdownList: {
    listStyle: 'none',
    margin: 0,
    flexGrow: 1,
    padding: `0 ${typography.pxToRem(24)}`,
    marginBlockEnd: typography.pxToRem(24),
    flexBasis: '33.33%',
    [breakpoints.up('md')]: {
      padding: `0 ${typography.pxToRem(40)}`,
    },
    [breakpoints.up('lg')]: {
      flexBasis: typography.pxToRem(510),
      marginBlockStart: 0,
      marginBlockEnd: 0,
      padding: `0 ${typography.pxToRem(24)}`,
    },
  },
  dropdownListFixedGrid: {
    [breakpoints.up('md')]: {
      paddingLeft: 0,
      paddingRight: 0,
    },
    [breakpoints.up('lg')]: {
      paddingLeft: 0,
      paddingRight: 0,
    },
  },
  backArrowContainer: {
    display: 'flex',
    alignItems: 'center',
    cursor: 'pointer',
    flexDirection: 'row',
    '& > div:first-of-type': {
      marginRight: typography.pxToRem(12),
    },
    '& > div:nth-of-type(2)': {
      borderBottom: 'none',
    },
    [breakpoints.up('md')]: {
      display: 'none',
    },
    padding: `${spacing(1)} 0`,
  },
  backArrowText: {
    ...type['18_medium'],
    color: brandColors.mediumBlue,
    marginBottom: '-2px',
    transition: 'border-bottom 400ms ease-out',
    [REDUCED_MOTION_MEDIA_QUERY]: {
      transition: 'none',
    },
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    borderBottom: 'none',
    paddingLeft: spacing(1),
  },
  backArrowTextDark: {
    color: brandColors.tintsChargeBlue60,
  },
  dropdownTitle: {
    color: brandColors.tintsNeutral20,
    textTransform: 'uppercase',
    padding: `${spacing(0)} 0 ${spacing(-1)} 0`,
    ...type['12_semibold'],
  },
  dropdownTitleDark: {
    color: brandColors.tintsOffWhite40,
  },
  link: {
    padding: `${typography.pxToRem(16)} 0 ${typography.pxToRem(16)} 0`,
    width: '100%',
  },
  linkSubtext: {
    ...type['14_regular'],
    color: brandColors.tintsNeutral20,
  },
  linkSubtextDark: {
    color: brandColors.tintsOffWhite40,
  },
  chip: {
    marginLeft: typography.pxToRem(12),
    '&.MuiChip-root': {
      ...type['12_regular'],
      color: brandColors.heroYellow10,
      backgroundColor: brandColors.heroYellow,
      '& span': {
        padding: `${typography.pxToRem(4)} ${typography.pxToRem(8)}`,
      },
    },
  },
  chipDark: {
    '&.MuiChip-root': {
      ...type['12_regular'],
      color: brandColors.primaryMain,
      backgroundColor: brandColors.tintsChargeBlue60,
    },
  },
  featured: {
    flexGrow: 1,
    padding: `0 ${spacing(2)} ${spacing(3)} ${spacing(2)}`,
    [breakpoints.up(ScreenSize.MEDIUM)]: {
      paddingLeft: spacing(1),
    },
    [breakpoints.up(ScreenSize.LARGE)]: {
      paddingLeft: spacing(1),
      paddingRight: spacing(1),
    },
    flexBasis: '66.66%',
  },
  featureCardWrapper: {
    height: typography.pxToRem(272),
    [breakpoints.up('sm')]: {
      height: typography.pxToRem(378),
    },
    [breakpoints.up('md')]: {
      height: typography.pxToRem(374),
    },
  },
  dropdownItem: {
    ...type['18_medium'],
    color: brandColors.mediumBlue,
    borderBottom: '2px solid rgba(0, 0, 0, 0.20)',
    marginBottom: '-2px',
    transition: 'border-bottom 400ms ease-out',
    [REDUCED_MOTION_MEDIA_QUERY]: {
      transition: 'none',
    },
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',

    '& svg': {
      display: 'inline',
      opacity: 0,
      transition: 'opacity 300ms ease-out',
      [REDUCED_MOTION_MEDIA_QUERY]: {
        transition: 'none',
      },
    },
    '&:hover svg': {
      display: 'inline',
      marginRight: 0,
      opacity: 1,
      transition: 'opacity 300ms ease-in',
      [REDUCED_MOTION_MEDIA_QUERY]: {
        transition: 'none',
      },
    },
    '& a': {
      textDecoration: 'none',
    },
    '&:hover': {
      borderBottom: `2px solid ${brandColors.primaryMain}`,
      marginBottom: '-2px',
      transition: 'border-bottom 400ms ease-in',
      [REDUCED_MOTION_MEDIA_QUERY]: {
        transition: 'none',
      },
      color: brandColors.primaryMain,
    },
  },
  dropdownItemDark: {
    color: brandColors.tintsChargeBlue60,
    borderBottom: '2px solid rgba(255, 255, 255, 0.30)',
    '&:hover': {
      borderBottom: `2px solid ${brandColors.white}`,
    },
    '&:hover svg': {
      color: brandColors.white,
    },
  },
  location: {
    ...type['18_medium'],
    color: brandColors.mediumBlue,
    padding: `${typography.pxToRem(24)}`,
    display: 'flex',
    flexDirection: 'row',
  },
}));

export default useStyles;
